// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientLabHead extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'PatientLabHeads'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			lab_order_number: this.attr(null),
			hn: this.attr(null),
			vn: this.attr(null),
			an: this.attr(null),
			department: this.attr(null),
			datas: this.attr(null),
			list_orderby: this.number(0)
		}
	}
}
